__turbopack_context__.v({
  "all": "PlasmicFeaturesMyGme-module__zuUzuW__all",
  "all2": "PlasmicFeaturesMyGme-module__zuUzuW__all2",
  "all3": "PlasmicFeaturesMyGme-module__zuUzuW__all3",
  "col2": "PlasmicFeaturesMyGme-module__zuUzuW__col2",
  "col3": "PlasmicFeaturesMyGme-module__zuUzuW__col3",
  "col4": "PlasmicFeaturesMyGme-module__zuUzuW__col4",
  "desktop": "PlasmicFeaturesMyGme-module__zuUzuW__desktop",
  "featuresCard___5TQtD": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard___5TQtD",
  "featuresCard__bRhPy": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__bRhPy",
  "featuresCard__bwFZy": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__bwFZy",
  "featuresCard__eatYl": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__eatYl",
  "featuresCard__flHle": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__flHle",
  "featuresCard__fszWh": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__fszWh",
  "featuresCard__g0MFs": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__g0MFs",
  "featuresCard__gb6VK": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__gb6VK",
  "featuresCard__gfcXr": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__gfcXr",
  "featuresCard__ig9AJ": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__ig9AJ",
  "featuresCard__iiiYe": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__iiiYe",
  "featuresCard__ipvSa": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__ipvSa",
  "featuresCard__jnFlJ": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__jnFlJ",
  "featuresCard__nSip7": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__nSip7",
  "featuresCard__ry66P": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__ry66P",
  "featuresCard__sOpi": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__sOpi",
  "featuresCard__uu09J": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__uu09J",
  "featuresCard__vU6E1": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__vU6E1",
  "featuresCard__vo6Zy": "PlasmicFeaturesMyGme-module__zuUzuW__featuresCard__vo6Zy",
  "featuresProductHeader___25K2Y": "PlasmicFeaturesMyGme-module__zuUzuW__featuresProductHeader___25K2Y",
  "featuresProductHeader___7Rpxq": "PlasmicFeaturesMyGme-module__zuUzuW__featuresProductHeader___7Rpxq",
  "featuresProductHeader__rnQty": "PlasmicFeaturesMyGme-module__zuUzuW__featuresProductHeader__rnQty",
  "h2___3Hu8L": "PlasmicFeaturesMyGme-module__zuUzuW__h2___3Hu8L",
  "h2__fFdiH": "PlasmicFeaturesMyGme-module__zuUzuW__h2__fFdiH",
  "h2__xJcJt": "PlasmicFeaturesMyGme-module__zuUzuW__h2__xJcJt",
  "header": "PlasmicFeaturesMyGme-module__zuUzuW__header",
  "header2": "PlasmicFeaturesMyGme-module__zuUzuW__header2",
  "header3": "PlasmicFeaturesMyGme-module__zuUzuW__header3",
  "header4": "PlasmicFeaturesMyGme-module__zuUzuW__header4",
  "img___3AIFh": "PlasmicFeaturesMyGme-module__zuUzuW__img___3AIFh",
  "img___4YnRm": "PlasmicFeaturesMyGme-module__zuUzuW__img___4YnRm",
  "img___6XVwM": "PlasmicFeaturesMyGme-module__zuUzuW__img___6XVwM",
  "img___7PVv": "PlasmicFeaturesMyGme-module__zuUzuW__img___7PVv",
  "img___9POVn": "PlasmicFeaturesMyGme-module__zuUzuW__img___9POVn",
  "img__ceYrC": "PlasmicFeaturesMyGme-module__zuUzuW__img__ceYrC",
  "img__e1NwB": "PlasmicFeaturesMyGme-module__zuUzuW__img__e1NwB",
  "img__i1BVf": "PlasmicFeaturesMyGme-module__zuUzuW__img__i1BVf",
  "img__iyqSa": "PlasmicFeaturesMyGme-module__zuUzuW__img__iyqSa",
  "img__jgPD": "PlasmicFeaturesMyGme-module__zuUzuW__img__jgPD",
  "img__jyi1W": "PlasmicFeaturesMyGme-module__zuUzuW__img__jyi1W",
  "img__l2YJb": "PlasmicFeaturesMyGme-module__zuUzuW__img__l2YJb",
  "img__nhAjy": "PlasmicFeaturesMyGme-module__zuUzuW__img__nhAjy",
  "img__nlflX": "PlasmicFeaturesMyGme-module__zuUzuW__img__nlflX",
  "img__oSYh": "PlasmicFeaturesMyGme-module__zuUzuW__img__oSYh",
  "img__qmmb4": "PlasmicFeaturesMyGme-module__zuUzuW__img__qmmb4",
  "img__qxEqC": "PlasmicFeaturesMyGme-module__zuUzuW__img__qxEqC",
  "img__rhlDw": "PlasmicFeaturesMyGme-module__zuUzuW__img__rhlDw",
  "img__s9Afo": "PlasmicFeaturesMyGme-module__zuUzuW__img__s9Afo",
  "img__ueeYy": "PlasmicFeaturesMyGme-module__zuUzuW__img__ueeYy",
  "img__w5X7K": "PlasmicFeaturesMyGme-module__zuUzuW__img__w5X7K",
  "key2": "PlasmicFeaturesMyGme-module__zuUzuW__key2",
  "key3": "PlasmicFeaturesMyGme-module__zuUzuW__key3",
  "key4": "PlasmicFeaturesMyGme-module__zuUzuW__key4",
  "list11": "PlasmicFeaturesMyGme-module__zuUzuW__list11",
  "list2": "PlasmicFeaturesMyGme-module__zuUzuW__list2",
  "list3": "PlasmicFeaturesMyGme-module__zuUzuW__list3",
  "list4": "PlasmicFeaturesMyGme-module__zuUzuW__list4",
  "list6": "PlasmicFeaturesMyGme-module__zuUzuW__list6",
  "list7": "PlasmicFeaturesMyGme-module__zuUzuW__list7",
  "listItem___22AfJ": "PlasmicFeaturesMyGme-module__zuUzuW__listItem___22AfJ",
  "listItem___59ZKm": "PlasmicFeaturesMyGme-module__zuUzuW__listItem___59ZKm",
  "listItem__dTcVv": "PlasmicFeaturesMyGme-module__zuUzuW__listItem__dTcVv",
  "logo__alngc": "PlasmicFeaturesMyGme-module__zuUzuW__logo__alngc",
  "logo__l0Sm": "PlasmicFeaturesMyGme-module__zuUzuW__logo__l0Sm",
  "logo__ua5X6": "PlasmicFeaturesMyGme-module__zuUzuW__logo__ua5X6",
  "mobile": "PlasmicFeaturesMyGme-module__zuUzuW__mobile",
  "myEvaluations": "PlasmicFeaturesMyGme-module__zuUzuW__myEvaluations",
  "row": "PlasmicFeaturesMyGme-module__zuUzuW__row",
  "row11": "PlasmicFeaturesMyGme-module__zuUzuW__row11",
  "row5": "PlasmicFeaturesMyGme-module__zuUzuW__row5",
  "row6": "PlasmicFeaturesMyGme-module__zuUzuW__row6",
  "row7": "PlasmicFeaturesMyGme-module__zuUzuW__row7",
  "row8": "PlasmicFeaturesMyGme-module__zuUzuW__row8",
  "row9": "PlasmicFeaturesMyGme-module__zuUzuW__row9",
  "sections": "PlasmicFeaturesMyGme-module__zuUzuW__sections",
  "sections2": "PlasmicFeaturesMyGme-module__zuUzuW__sections2",
  "sections3": "PlasmicFeaturesMyGme-module__zuUzuW__sections3",
  "svg__aEdPb": "PlasmicFeaturesMyGme-module__zuUzuW__svg__aEdPb",
  "svg__qjoSx": "PlasmicFeaturesMyGme-module__zuUzuW__svg__qjoSx",
  "svg__sbYDg": "PlasmicFeaturesMyGme-module__zuUzuW__svg__sbYDg",
  "tablet": "PlasmicFeaturesMyGme-module__zuUzuW__tablet",
  "title": "PlasmicFeaturesMyGme-module__zuUzuW__title",
  "title2": "PlasmicFeaturesMyGme-module__zuUzuW__title2",
  "title3": "PlasmicFeaturesMyGme-module__zuUzuW__title3",
});
